import './filters-mobile.scss'

import _ from 'lodash'
import React, { useEffect, useRef, useState } from 'react'

import { ReactComponent as ChevronIcon } from '../../assets/icons/crypto_general_icons_chevron-down_clean.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/crypto_general_icons_close.svg'
import { useCategories } from '../../hooks/useCategories'
import { withTrans } from '../../i18n/withTrans'
import Button from '../button/button'
import { useHashUrlFilter } from '../filters/use-hash-url-filter'
import SearchBoxFilter from '../search-box-filter/search-box-filter'

const FilterMobile = ({
  title,
  titleTwo,
  selectedCategories = {},
  type = 'event',
  typeTwo = undefined,
  onClick,
  t,
}) => {
  const [subCategories, setSubCategories] = useState([])
  const [subCategoriesTwo, setSubCategoriesTwo] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [categories, setCategories] = useState([])
  const { withSubCategories } = useCategories()

  const selectedRef = useRef(selectedCategories)
  useEffect(() => {
    selectedRef.current = selectedCategories
  }, [selectedCategories])

  const handleOnChangeFilters = (cat) => {
    selectedRef.current[type] = cat
  }

  const handleOnChangeFiltersTwo = (cat) => {
    selectedRef.current[typeTwo] = cat
  }

  const applyFilters = () => {
    onClick(selectedRef.current)
    setIsOpen(false)
    document.body.style.overflowY = 'unset'
    document.body.style.height = 'unset'
  }

  const handleResetFilters = () => {
    if (typeTwo) {
      onClick({ [type]: null, [typeTwo]: null })
    } else {
      onClick({ [type]: null })
    }

    selectedRef.current = {}
    setIsOpen(false)
    document.body.style.overflowY = 'unset'
    document.body.style.height = 'unset'
  }

  useEffect(() => {
    const cat = _.map(withSubCategories, (c) => ({
      id: c.description,
      value: c.description,
      label: c.name,
      description: c.description,
      children: c.wpChildren.map((child) => ({
        label: child.name,
        value: child.description,
        description: child.description,
      })),
    }))
    setCategories(cat)
  }, [withSubCategories])

  useEffect(() => {
    const category = _.filter(withSubCategories, (c) => c.description === type)
    setSubCategories(_.get(_.head(category), 'wpChildren', []))
    if (typeTwo) {
      const category2 = _.filter(
        withSubCategories,
        (c) => c.description === typeTwo
      )
      setSubCategoriesTwo(_.get(_.head(category2), 'wpChildren', []))
    }
  }, [type, typeTwo, withSubCategories])

  useHashUrlFilter(
    selectedCategories,
    subCategories,
    subCategoriesTwo,
    type,
    typeTwo,
    onClick
  )

  return (
    <div className="container-filter-mobile">
      {!isOpen && (
        <div className="box-filter-mobile">
          <p className="text-type-filters">
            Filter{' '}
            <span>
              ({Object.values(selectedCategories).filter((c) => !!c).length})
            </span>
          </p>
          <div
            className="box-icon-chevron"
            onClick={() => {
              document.body.style.overflowY = 'hidden'
              document.body.style.height = '100%'
              setIsOpen(true)
            }}
          >
            <ChevronIcon className="icon-chevron" />
          </div>
        </div>
      )}
      {isOpen && (
        <div className="container-filters-mobile">
          <div className="box-filters-mobile">
            <div className="header-filter-mobile">
              <span
                className="closed-button"
                onClick={() => {
                  setIsOpen(false)
                  document.body.style.overflowY = 'unset'
                  document.body.style.height = 'unset'
                }}
              >
                <CloseIcon className="icon-close" />
              </span>
              <p className="title-filter-mobile">Filter</p>
              <span className="reset-button" onClick={handleResetFilters}>
                Reset
              </span>
            </div>
            <div className="content-filters-mobile">
              <SearchBoxFilter
                title={t(`ui.filters.${title}`)}
                type={type}
                isMobile={true}
                options={categories}
                selectedSortBy={selectedCategories[type]}
                onChange={(array) => handleOnChangeFilters(array)}
              />
            </div>
            {typeTwo && (
              <div className="content-filters-mobile">
                <SearchBoxFilter
                  title={t(`ui.filters.${titleTwo}`)}
                  type={typeTwo}
                  isMobile={true}
                  options={categories}
                  selectedSortBy={selectedCategories[typeTwo]}
                  onChange={(array) => handleOnChangeFiltersTwo(array)}
                />
              </div>
            )}
          </div>
          <div className="button-filter-mobile">
            <Button title="apply" onPress={applyFilters} />
          </div>
        </div>
      )}
    </div>
  )
}

export default withTrans(FilterMobile)
